import { render, staticRenderFns } from "./EditRegionSettings.vue?vue&type=template&id=14d3ee4e"
import script from "./EditRegionSettings.vue?vue&type=script&lang=js"
export * from "./EditRegionSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports